const listize = (...args) => args.filter((x) => x).join(' ')

export { listize }
